// import { KTCard } from '../../../../../../_metronic/helpers'
// import { Card4 } from '../../../../../../_metronic/partials/content/cards/Card4'
// import { UsersListHeader } from '../../../data-administration/data-admininstration-list/components/header/UsersListHeader'
// import { ListViewProvider } from '../../../data-administration/data-admininstration-list/core/ListViewProvider'
// import { QueryRequestProvider } from '../../../data-administration/data-admininstration-list/core/QueryRequestProvider'
// import { QueryResponseProvider } from '../../../data-administration/data-admininstration-list/core/QueryResponseProvider'
// import { UserEditModal } from '../../../data-administration/data-admininstration-list/form-edit-modal/CoomonEditModal'
// import { UsersTable } from '../../../data-administration/data-admininstration-list/table/UsersTable'
// import { roleColumns } from './_columns'

// const mockedData = [
//   {
//     gender: 'Male',
//     email: 'ashok@gmail.com',
//     fullAddress: 'New Baneshwor, Kathmandu',
//     mobile: '9860105561',
//     joinDate: '2023/09/05',
//     currentLevel: 'Manager',
//     pointEarned: 45,
//     pointRedeemed: 5,
//     name: 'Ashok Karki',
//     birthday: '1992/12/22',
//   },
//   {
//     gender: 'Femal',
//     email: 'aleshika@gmail.com',
//     fullAddress: 'Old Baneshwor, Kathmandu',
//     mobile: '9860105560',
//     joinDate: '2023/09/06',
//     currentLevel: 'Employee',
//     pointEarned: 5,
//     pointRedeemed: 15,
//     name: 'Aleshki Chheri',
//     birthday: '1996/06/06',
//   },
// ]

// const UserManagementList = () => {
//   return (
//     <KTCard>
//       <UsersListHeader label='Add new' />
//       <UsersTable /* mockedData={mockedData} */ columnProps={roleColumns} />
//       <UserEditModal formName='TransportModalForm' />
//     </KTCard>
//   )
// }

// const TransportListWrapper = () => (
//   <QueryRequestProvider initialValue={{ initialApi: 'transports' }}>
//     <QueryResponseProvider>
//       <ListViewProvider>
//         <UserManagementList />
//       </ListViewProvider>
//     </QueryResponseProvider>
//   </QueryRequestProvider>
// )

// export { TransportListWrapper }






import React, { useState } from 'react'
import { KTCard } from '../../../../../../_metronic/helpers'
import { Card4 } from '../../../../../../_metronic/partials/content/cards/Card4'
import { UsersListHeader } from '../../../data-administration/data-admininstration-list/components/header/UsersListHeader'
import { ListViewProvider } from '../../../data-administration/data-admininstration-list/core/ListViewProvider'
import { QueryRequestProvider } from '../../../data-administration/data-admininstration-list/core/QueryRequestProvider'
import { QueryResponseProvider } from '../../../data-administration/data-admininstration-list/core/QueryResponseProvider'
import { UserEditModal } from '../../../data-administration/data-admininstration-list/form-edit-modal/CoomonEditModal'
import { UsersTable } from '../../../data-administration/data-admininstration-list/table/UsersTable'
import { roleColumns } from './_columns'

const mockedData = [
  {
    gender: 'Male',
    email: 'ashok@gmail.com',
    fullAddress: 'New Baneshwor, Kathmandu',
    mobile: '9860105561',
    joinDate: '2023/09/05',
    currentLevel: 'Manager',
    pointEarned: 45,
    pointRedeemed: 5,
    name: 'Ashok Karki',
    birthday: '1992/12/22',
  },
  {
    gender: 'Femal',
    email: 'aleshika@gmail.com',
    fullAddress: 'Old Baneshwor, Kathmandu',
    mobile: '9860105560',
    joinDate: '2023/09/06',
    currentLevel: 'Employee',
    pointEarned: 5,
    pointRedeemed: 15,
    name: 'Aleshki Chheri',
    birthday: '1996/06/06',
  },
]

const UserManagementList = ({ selectedTransport, onTransportChange }) => {
  return (
    <KTCard>
      <div className="d-flex justify-content-between align-items-center mb-4">
        {/* <div className="d-flex align-items-center">
          <label className="me-2 fw-bold">Select Transport:</label>
          <select
            className="form-select"
            style={{ width: '150px' }}
            value={selectedTransport}
            onChange={(e) => onTransportChange(e.target.value)}
          >
            <option value="Truck">Truck</option>
            <option value="Ship">Ship</option>
            <option value="Pipeline">Pipeline</option>
          </select>
        </div> */}
        <div className="d-flex flex-column" style={{
          marginTop: '15px',
          marginLeft: '30px'
        }}>
          <label className="fw-bold" style={{ marginBottom: '4px' }}>
            Select Transport:
          </label>
          <select
            className="form-select"
            style={{
              width: '150px',
              marginTop: '5px'
              // Removed marginLeft from select since parent div already has marginLeft
            }}
            value={selectedTransport}
            onChange={(e) => onTransportChange(e.target.value)}
          >
            <option value="Truck">Truck</option>
            <option value="Ship">Ship</option>
            <option value="Pipeline">Pipeline</option>
          </select>
        </div>
        <UsersListHeader label='Add new' />
      </div>
      <UsersTable /* mockedData={mockedData} */ columnProps={roleColumns} />
      <UserEditModal formName='TransportModalForm' />
    </KTCard>
  )
}

const TransportListWrapper = () => {
  const [selectedTransport, setSelectedTransport] = useState('Truck')

  const handleTransportChange = (transport) => {
    setSelectedTransport(transport)
  }

  return (
    <QueryRequestProvider
      key={selectedTransport}
      initialValue={{ initialApi: `emissions?vehicleType=${selectedTransport}` }}
    >
      <QueryResponseProvider>
        <ListViewProvider>
          <UserManagementList
            selectedTransport={selectedTransport}
            onTransportChange={handleTransportChange}
          />
        </ListViewProvider>
      </QueryResponseProvider>
    </QueryRequestProvider>
  )
}

export { TransportListWrapper }